import styled from 'styled-components';

import Column from '@sdk/components/ui/spacing/Column';

export const SideImg = styled(Column)`
  pointer-events: none;

  @media (max-width: 1024px) {
    display: none;
  }
`;
